module.exports = __webpack_public_path__ + "static/bg-video-698f53b7f74efe59f4e8c562938d4dd8.mp4";